// import router from '@/router'
import axios from 'axios'
import { get } from 'lodash'

function assert(cond, message) {
    if (!(cond)) {
        throw message || 'assertion failed'
    }
}

const state = () => ({
    jwt: JSON.parse(localStorage.getItem('jwt')),
})

const getters = {
    jwt: (state, getters, rootState, rootGetters) => {
        // console.log('VUEX auth getters jwt')
        return state.jwt
    },
    authorized: (state, getters, rootState, rootGetters) => {
        // console.log('VUEX auth getters authorized')
        const accessToken = get(getters.jwt, 'tokens.access', null)
        return (accessToken !== null)
    },
    bearerToken: (state, getters, rootState, rootGetters) => {
        return 'Bearer ' + get(getters.jwt, 'tokens.access', null)
    },
    refreshToken: (state, getters, rootState, rootGetters) => {
        return get(getters.jwt, 'tokens.refresh', null)
    },
    nextRedirect: (state, getters, rootState, rootGetters) => {
        const redirectRouteStr = localStorage.getItem('nextRedirect')
        console.log('VUEX getters: nextRedirect redirectRouteStr', redirectRouteStr)
        if (redirectRouteStr === null) {
            return null
        }
        const retVal = JSON.parse(redirectRouteStr)
        console.log('VUEX getters: nextRedirect', retVal)

        return retVal
    },
}

// $store.dispatch('auth/authRedirect')
const actions = {
    registerUser: (context, payload) =>
        new Promise((resolve, reject) => {
            let apiEndpoint = `/auth/register/${ payload.token }`
            // let apiEndpoint = '/auth/register'

            axios.put(apiEndpoint, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        }),
    changePassword: (context, payload) =>
        new Promise((resolve, reject) => {
            let apiEndpoint = '/auth/password/reset'

            axios.put(apiEndpoint, payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        }),

    authRedirect: (context, { logout = false } = {}) => {
        console.log('VUEX auth actions authRedirect')
        return new Promise((resolve, reject) => {
            let config = {}
            if (process.env.NODE_ENV === 'development') {
                config = {
                    params: {
                        useLocalCallback: true,
                    },
                }
            }

            let apiEndpoint = '/auth/login'
            axios.get(apiEndpoint, config)
                .then(response => {
                    console.log('VUEX auth authRedirect then', response)

                    let pingUrl = new URL(response.data.url)
                    // Logins started here stop at the unified portal's landing page; the user
                    // picks the Enforce tile to come back. Only the appliance SSO hand-off
                    // still needs the portal to send the user back to finish the instance login.
                    if (context.getters.nextRedirect?.path !== '/auth/instance/login') {
                        pingUrl.searchParams.delete('redirect_uri')
                        context.commit('SET_NEXT_REDIRECT', null)
                    }
                    if (logout) {
                        // gmc-web can't reach the session the login page keeps on its own origin.
                        // Its logout page, next to the login page, clears that session so the user
                        // is not sent straight back to the unified portal still logged in.
                        pingUrl = new URL('logout', pingUrl)
                    }
                    console.log('VUEX auth pingUrl', pingUrl.toString())
                    location.href = pingUrl.toString()

                    resolve(response)
                })
                .catch(error => {
                    console.log('VUEX auth authRedirect catch!', error)

                    context.commit('DEAUTHORIZE')
                    reject(error)
                })
        })
    },
    login: (context, credentials) => {
        console.log('VUEX auth actions login')

        return new Promise((resolve, reject) => {
            let apiEndpoint = '/auth/login'
            axios.post(apiEndpoint, credentials)
                .then(response => {
                    context.commit('SET_JWT', response.data)
                    const params = new URLSearchParams(window.location.search);
                    
                    const redirect_uri = params.get('redirect_uri');
                    if(redirect_uri) {
                        window.location.href =window.location.origin + redirect_uri
                    }
                    resolve(response)
                })
                .catch(error => {
                    context.commit('DEAUTHORIZE')
                    reject(error)
                })
        })
    },
    logout: ({ commit, state, getters, dispatch, rootState, rootGetters }) => {
        // console.log('VUEX auth actions logout')

        return new Promise((resolve, reject) => {
            const refreshToken = get(rootGetters['auth/jwt'], 'tokens.refresh', null)
            console.log('VUEX auth actions logout refreshToken', refreshToken)

            let apiEndpoint = '/auth/jwt/refresh/' + refreshToken

            axios.delete(apiEndpoint)
                .then(response => {
                    // commit('auth/SET_JWT', response.data, { root: true })

                    // const currentRoute = router.currentRoute.name

                    /*
                     if (currentRoute === 'users') {
                     location.reload()
                     } else {
                     router.push({ name: 'users' }).catch(() => {})
                     }
                     */


                    /*
                     dispatch({
                     type: 'flash/addFlash',
                     title: 'End User Impersonation',
                     flashType: 'success',
                     }, { root: true }).then(result => {
                     })
                     */
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    deauthorize: (context) => {
        console.log('VUEX auth actions deauthorize')
        context.commit('SET_JWT', null)
        // localStorage.clear()
        localStorage.removeItem('jwt')
    },

    setNextRedirect: (context, nextRedirect) => {
        context.commit('SET_NEXT_REDIRECT', nextRedirect)
    },

}

// $store.commit('auth/SET_JWT', response.data)
const mutations = {
    SET_JWT: (state, jwt) => {
        console.log('VUEX auth mutations SET_JWT jwt', jwt)
        state.jwt = jwt
        const jwtString = JSON.stringify(jwt)
        localStorage.setItem('jwt', jwtString)
    },
    DEAUTHORIZE: (state) => {
        // localStorage.clear()
        localStorage.removeItem('jwt')
    },
    SET_NEXT_REDIRECT: (state, nextRedirect) => {
        console.log('VUEX auth mutations SET_NEXT_REDIRECT: ', nextRedirect)
        if (nextRedirect === null) {
            console.log('VUEX auth mutations SET_NEXT_REDIRECT: null')

            localStorage.removeItem('nextRedirect')
        } else {
            // The 'matched' property breaks stringify due to 'cyclic object' errors
            const theRoute = {
                'path': nextRedirect.path,
                'params': nextRedirect.params,
                'query': nextRedirect.query,
            }
            console.log('VUEX auth mutations SET_NEXT_REDIRECT 2: ', theRoute)
            localStorage.setItem('nextRedirect', JSON.stringify(theRoute))
        }
        console.log('VUEX auth mutations SET_NEXT_REDIRECT: DONE')
    },

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
